<script lang="ts">
import { defineComponent } from 'vue';
import ModuleCart from '@/generated/modules/ModuleCart.vue';

export default defineComponent({
  extends: ModuleCart,
  data() {
    return {
      wizardDone: true,
    };
  },
});
</script>
